<template>
  <div class="d-flex" :class="!isCheckoutHeader && 'flex-wrap'">
    <div :class="!isCheckoutHeader &&  'mb-1'">
      <VChip
        v-if="!appConfig.isNightCardsSupport && rideType"
        class="body-2 mr-4"
      >
        {{ $t(`bookingForm.${rideType}`) }}
      </VChip>
    </div>
    <div :class="!isCheckoutHeader &&  'mb-1'">
      <VChip
        v-if="tripType"
        class="body-2 mr-4"
      >
        {{ $t(`bookingForm.${tripType}`) }}
      </VChip>
    </div>
    <div :class="!isCheckoutHeader &&  'mb-1'">
      <VChip
        v-if="vehicleCategoryName"
        class="body-2 mr-4"
      >
        {{ vehicleCategoryName }}
      </VChip>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Options',
};
</script>

<script setup lang="ts">
defineProps({
  appConfig: {
    type: Object,
    default: null,
  },
  rideType: {
    type: String,
    default: null,
  },
  tripType: {
    type: String,
    default: null,
  },
  vehicleCategoryName: {
    type: String,
    default: null,
  },
  isCheckoutHeader: {
    type: Boolean,
    default: false,
  },
});

function pricePerRide(price: number) {
  return Number(price || 0).toFixed(2);
}

function pricePerFeature(price: number) {
  return Number(price || 0).toFixed(2);
}
</script>
